import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useEventContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";
import {
  clearActionMeta,
  createEventTravelBlock,
  dataMetaSelector,
  dispatchGetEventTravelBlocks,
} from "Bands/state";
import { BAND_ACTIONS } from "Bands/types";
import { useBandRoute, useClearActionMetaOnUnMount } from "Bands/utils";
import { useHistory } from "react-router-dom";
import { copy } from "shared/assets";
import { Card, Loader, Message } from "shared/components";
import { Spacer } from "shared/layout";
import { IAPIState, IStatus } from "shared/types";

const { travelBlock: blockCopy } = copy;

export const CreateTravelBlockPage = () => {
  const history = useHistory();
  const { getPath } = useBandRoute();
  const dispatch = useDispatch();
  const { api: apiMeta, id: blockId } = useSelector(
    dataMetaSelector(BAND_ACTIONS.createEventTravelBlock)
  );

  const { eventId, eventPath } = useEventContext();

  useClearActionMetaOnUnMount(BAND_ACTIONS.createEventTravelBlock);

  // create a new travel block as soon as this page mounts
  useEffect(() => {
    if (!eventPath) return;

    dispatch(
      createEventTravelBlock({
        title: blockCopy.title,
        event: eventPath,
      })
    );
  }, [dispatch, eventPath]);

  useEffect(() => {
    if (!blockId || !eventId) return;

    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(clearActionMeta(BAND_ACTIONS.createEventTravelBlock));

      dispatchGetEventTravelBlocks(dispatch, eventId);

      history.replace(
        getPath(BAND_PATHS.EDIT_TRAVEL_BLOCK, {
          params: { eventId, blockId },
        })
      );
    }
  }, [dispatch, apiMeta, blockId, eventId, getPath, history]);

  const renderContent = useMemo(() => {
    switch (apiMeta?.status) {
      case IAPIState.pending:
        return (
          <Spacer size="s" align="center">
            <Loader size="l" />
            <p>{blockCopy.create.title}</p>
          </Spacer>
        );
      case IAPIState.failed:
        return <Message message={copy.errors.general} status={IStatus.error} />;
      case IAPIState.succeeded:
        return <Message message={blockCopy.create.messages.success} status={IStatus.success} />;
      default:
        break;
    }
  }, [apiMeta?.status]);

  return <Card title={blockCopy.create.title}>{renderContent}</Card>;
};
